<dialog-header [label]="'MENUBAR.SELECT_VIDEO' | translate" [dialogRef]='dialogRef' [object]='this'></dialog-header>
<mat-dialog-content>
  <mat-selection-list [multiple]="false" #filesSelectionList dense style="max-height: 300px; overflow-y: scroll">
    <mat-list-option *ngFor="let file of filesList; index as i" [selected]="i == 0">{{file}}</mat-list-option>
  </mat-selection-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="true" [disabled]="!canPlay" (click)="onPlay()" cdkFocusInitial>{{'ACTIONS.PLAY' | translate}}</button>
  <button mat-stroked-button [mat-dialog-close]="false">{{'ACTIONS.CLOSE' | translate}}</button>
</mat-dialog-actions>
